module.exports = __webpack_public_path__ + "25199842c3975ff37ed3ceb36bbd5b8e.svg";